import styled from 'styled-components';

import {
  Colors,
  Sizes,
} from '@noitada/shared/constants';



export interface IProps {
  backgroundColor?: string;
  color?: string;
  borderColor?: string;
  fontWeight?: string;
}



export const MenuLevelImageContent = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: ${Colors.profileToolbar};
  width: ${Sizes.imageDrawer}px;
  height: ${Sizes.imageDrawer}px;
  border-color: ${(props: IProps) => props.borderColor};
  border-style: solid;
  border-width: 3px;
  border-radius: ${Sizes.cardRadius}px;
`;

export const MenuImageLevel = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: center;
`;

export const MenuPlaceImage = styled.img`
  height: 53px;
  width: 53px;
  margin-bottom: 3px;
  background-color: ${Colors.profileToolbar};
  border-radius: ${Sizes.cardRadius}px;
  object-fit: cover;
`;

export const MenuTextLevel = styled.p`
  background-color: ${(props: IProps) => props.backgroundColor};
  color: ${(props: IProps) => props.color};
  height: 22px;
  padding-top: 1px;
  font-size: 14px;
  font-weight: ${(props: IProps) => props.fontWeight};
  text-align: center;
`;
